export default {
    // Placeholder - will be populated when reviewing settings pages
};

